module.exports = __webpack_public_path__ + "static/media/chess-queen-alt.7f98bca9.svg";